<template>
	<div class="bottom">
		<div class="footer" :style="{'backgroundColor':bgColor}" :class="border ? 'borderTop' : ''">
			<div style="height: 20px;"></div>
			<div class="w1200">
				<div class="footer_down">
					<div class="left">
						<h3>山东恒达知识产权股份有限公司</h3>
						<div style="margin-top:15px;">
							<div style="color: #333;padding-bottom:10px;">
								市场部：13256314966
							</div>
							<div style="color: #333;padding-bottom:10px;">
								商版部：0631-5678759
							</div>
							<div style="color: #333;padding-bottom:10px;">
								电子邮箱：hengdateam@163.com
							</div>
							<div style="color: #333;padding-bottom:10px;">
								威海恒誉润达专利代理事务所（普通合伙)：0631-5679759
							</div>
							<div style="color: #333;padding-bottom:10px;">
								恒达知识产权研究院：0631-7172066
							</div>
						</div>
					</div>
					<div class="flink position-relative">
						
						<h3>友情链接</h3>
						<div style="margin-top:15px ;">
							<div class="flinker" style="float: left;">
								<a href="https://www.cnipa.gov.cn/" target="_blank" style="padding-bottom:8px;">国家知识产权局</a>
								<a href="http://amr.shandong.gov.cn/" target="_blank" style="padding-bottom: 8px;">山东省市场监督管理局</a>
								<a href="http://scjgj.weihai.gov.cn/" target="_blank" style="padding-bottom: 8px;">威海市市场监督管理局</a>
								<a href="http://chinaip.cnipa.gov.cn/" target="_blank">重点产业专利信息服务平台</a>
							</div>
							<div></div>
							<div style="width: 1px;border: 1px solid #999; height:100px;position: absolute;right:-200px;top:20px;"></div>
						</div>
					</div>
					<div class="right">
						<ul>
							<li>
								<img src="../../assets/img/footImg/hdzcxy_ewm.jpg" alt="" />
								<h3>恒达知产学苑</h3>
							</li>
							<li>
								<img src="../../assets/img/footImg/hdzscq_ewm.jpg" alt="" />
								<h3>山东恒达知识产权</h3>
							</li>
						</ul>
					</div>
				</div>
				<div class="footer_copyright">
					<span style="color: #333;">
						<div style="font-size: 16px;margin-bottom: 10px;color: #000;">
							<div>总部地址：山东省威海市高新区火炬创新创业基地A座14层</div>
              <div>威海 | 北京 | 潍坊 | 济宁 | 烟台 | 青岛 | 聊城 | 枣庄 | 运城 | 呼和浩特</div>
              <div>泰安 | 临沂 | 东营 | 德州 | 齐齐哈尔 | 兴安盟 | 济南 | 日照 | 安阳</div>
<!--							<div>潍坊分公司地址：山东省潍坊市奎文区北海路胜利街财富商务大厦2408室</div>-->
<!--							<div>济宁分公司地址：山东省邹城市西外环路1888号科技大学工业园区三号综合楼501室</div>-->
						</div>
						<a href="http://beian.miit.gov.cn/" target="_blank" style="color: #333;">鲁ICP备17008703号-1</a>
						Inc.All rights reserved.</span>
					<div class="beian"><!-- <a href="#"><img src="../../assets/img/footImg/ba.png"/>&nbsp;鲁公网安备 000000000号</a> --> <a href="#"><img src="../../assets/img/footImg/gs.gif"/>&nbsp;威海市市场监督管理局</a></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
			bgColor: {
				type: String,
				default:''
			},
			border:{
				type:Boolean,
				default:false
			}
		},
	}
</script>

<style scoped>
	.w1200 {
	    width: 1200px;
	    margin: 0 auto;
	}
	.w1200:after {
	    content: "";
	    width: 0;
	    height: 0;
	    display: block;
	    clear: both;
	}
	.bottom .register {
	    background: url(../../assets/img/footImg/foot_sgin.jpg) no-repeat center top;
	    height: 160px;
	    padding-top: 70px;
	    color: #fff;
	}
	.bottom .register h2 {
	    text-align: center;
	    font-size: 24px;
	}
	.bottom .register a {
	    display: block;
	    width: 170px;
	    height: 45px;
	    line-height: 44px;
	    color: #fff;
	    background: #14A8FF;
	    border-radius: 5px;
	    margin: 30px auto;
	    font-size: 18px;
	    text-align: center;
	}
	.bottom .footer {
		height: 416px;
		background-image: url(../../assets/img/footImg/footerBg.jpg);
	}
	.borderTop{
		border-top: 1px solid #eee;
	}
	.bottom .footer .w1200 {
	    padding: 0 10px;
	}
	.bottom .footer .footer_top ul li {
	    float: left;
	    width: 278px;
	    height: 78px;
	    line-height: 78px;
	    border: 1px solid #333;
	    text-indent: 98px;
	    color: #aaaaaa;
	    margin-right: 20px;
	}
	.bottom .footer .footer_top ul li:last-child {
	    margin-right: 0;
	}
	.bottom .footer .footer_top:after, .bottom .footer .footer_down:after {
	    content: "";
	    display: block;
	    height: 0;
	    clear: both;
	    visibility: hidden;
	    overflow: hidden;
	}
	.bottom .footer .footer_top ul li:nth-child(1) {
	    background: url(../../assets/img/footImg/foot_icon1.png) no-repeat 34px center;
	}
	.bottom .footer .footer_top ul li:nth-child(2) {
	    background: url(../../assets/img/footImg/foot_icon2.png) no-repeat 34px center;
	}
	.bottom .footer .footer_top ul li:nth-child(3) {
	    background: url(../../assets/img/footImg/foot_icon3.png) no-repeat 34px center;
	}
	.bottom .footer .footer_top ul li:nth-child(4) {
	    background: url(../../assets/img/footImg/foot_icon4.png) no-repeat 34px center;
	}
	.bottom .footer .footer_tel {
	    border-bottom: 1px solid #333;
	    height: 90px;
	    margin: 0 auto;
	    width: 1180px;
	    padding-top: 30px;
	    color: #aaa;
	}
	.bottom .footer .footer_tel .tel {
	    float: left;
	    font-size: 16px;
	    width: 180px;
	    height: 65px;
	    background: url(../../assets/img/footImg/foot_icon5.png) no-repeat 30px 0;
	    padding-left: 100px;
	}
	.bottom .footer .footer_tel ul li {
	    height: 90px;
	    line-height: 60px;
	    display: inline-block;
	    padding: 0 20px;
	}
	.bottom .footer .footer_tel ul li:first-child {
	    padding-left: 0;
	}
	.bottom .footer .footer_down {
	    padding-top: 20px;
	}
	.bottom .footer .footer_down .left {
	    float: left;
	    width: 450px;
	    padding-right: 20px;
	}
	.bottom .footer .footer_down .left h3, .bottom .footer .footer_down .flink h3 {
	    font-size: 16px;
	    color: #000;
	    font-weight: bold;
	}
	.bottom .footer .footer_down .left p, .bottom .footer .footer_down .flink .flinker {
	    font-size: 16px;
	}
	.bottom .footer .footer_down .left p a, .bottom .footer .footer_down .flink .flinker a {
	    font-size: 14px;
	    color: #000;
	    white-space: nowrap;
	    display: inline-block;
	}
	.bottom .footer .footer_down .left p a:hover, .bottom .footer .footer_down .flink .flinker a:hover {
	    color: #C32A1A;
	}
	.bottom .footer .footer_down .flink {
	    float: left;
	    width: 120px;
	    padding-right: 20px;
	}
	.bottom .footer .footer_down .right {
	    float: right;
	}
	.bottom .footer .footer_down .right ul li {
	    float: left;
	    width: 120px;
	    height: 150px;
	    margin-right: 40px;
	    text-align: center;
	}
	.bottom .footer .footer_down .right ul li img{
		width: 115px;
		height: 115px;
	}
	.bottom .footer .footer_down .right ul li:last-child {
	    margin-right: 0;
	}
	.bottom .footer .footer_down .right ul li h3 {
	    color: #888;
	    padding-top: 15px;
	    font-weight: normal;
	    font-size: 14px;
	    text-align: center;
	}
	.bottom .footer .footer_copyright {
		border-top: 1px solid #eee;
	   text-align: center;
	   padding-top:10px;
	}
	.bottom .footer .footer_copyright div {
	    line-height: 30px;
	    color: #333;
	    font-size: 14px;
	}
	.bottom .footer .footer_copyright div.beian a {
	    color: #333;
	    padding-right: 20px;
	    display: inline-block;
	}
	.bottom .footer .footer_copyright div.beian a img {
	    vertical-align: middle;
	}
</style>
